import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, IconButton, Link } from '@mui/material'

import { getRoute, routePaths } from '../../../constants'
// import { Logger, LoggerTypes } from '../../../utils'
import { Icon, iconNames } from '../../icons'
import './style.scss'

/**
 * Display the right Breadcrumbs navigation section.
 *
 * @returns {Breadcrumbs}
 */
export const HeaderLeft = ({ currentProject, currentScenario }) => {
  const { t } = useTranslation()

  // Logger.trace(LoggerTypes.CONTAINER, 'HeaderLeft.render()', { currentProject, currentScenario })

  return (
    <Breadcrumbs className="HeaderLeft" aria-label="breadcrumb" separator="/">
      <IconButton
        size="small"
        color="inherit"
        disableRipple={true}
        disableFocusRipple={true}
        href={routePaths.PROJECT_LIST}
      >
        <Icon name={iconNames.HOME} size={14} />
        <span className="home">{t('home')}</span>
      </IconButton>
      {currentProject && (
        <Link underline="hover" color="inherit" href={getRoute(routePaths.SCENARIO_LIST, { pid: currentProject.id })}>
          {currentProject.name || 'N/A'}
        </Link>
      )}
      {currentProject && currentScenario && (
        <Link
          underline="hover"
          color="inherit"
          href={getRoute(routePaths.SCENARIO_FLOW_GROUPS, { pid: currentProject.id, sid: currentScenario.id })}
        >
          {currentScenario.name || 'N/A'}
        </Link>
      )}
    </Breadcrumbs>
  )
}

HeaderLeft.displayName = 'HeaderLeft'

HeaderLeft.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object
}

HeaderLeft.defaultProps = {
  currentProject: null,
  currentScenario: null
}
